import React, { useState } from "react";
import Navbar from "../components/Navbar";
import TourManagementWelcomeModal from "../components/Modal/TourManagementWelcomeModal";
import { useNavigate } from "react-router-dom";
import { Paths } from "../router/Paths";
import useOnLoadPage from "../hooks/useOnLoadPage";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../app/store";
import { setPackageData } from "../reducer/tourReducer";

const AiFilterPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  
  const { packageData } = useSelector((state: RootState) => state.tour);
  
  const [text, setText] = useState<string>(packageData.automaticDetail || "");

  useOnLoadPage({ tabActive: "home" });

  const handleCreateContent = () => {
    dispatch(
      setPackageData({
        automaticDetail: text,
      })
    );
    navigate(Paths.tourManagementPackageName);
  };

  const handleSkip = () => {
    navigate(Paths.tourManagementPackageName);
  };

  return (
    <div className={Classname.maxWidth}>
      <Navbar />
      <TourManagementWelcomeModal />
      <div className={Classname.backgroundMain}>
        <div className={Classname.innerContainer}>
          <div className={Classname.betaStyle}>BETA</div>
          <p className={Classname.boldText}>
            Welcome to our automatic content creator
          </p>
          <p>
            Our automated assistant can fill out a large part of the product
            creation form for you, using your existing content. It saves you
            time and helps create content that is optimal for your activity best
            performance.
          </p>
          <p className={Classname.marginY}>
            Do not worry, you’ll be able to update it, before it goes live.
          </p>
          <p className={Classname.boldText}>
            Get started by copy-pasting a detailed description about your
            activity here.
          </p>
          <textarea
            placeholder="Enter your details"
            value={text}
            className={Classname.textAreaStyle}
            onChange={(e) => setText(e.target.value)}
          ></textarea>
          <div className={Classname.buttonContainer}>
            <button className={Classname.cancelButton} onClick={handleSkip}>
              Skip and proceed manually
            </button>

            <button
              className={Classname.submitButton}
              onClick={handleCreateContent}
            >
              Create content
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

const Classname = {
  maxWidth: "w-full mx-auto ",
  backgroundMain:
    "bg-[#F4F3F3] lg:p-10 p-2 w-full h-screen flex pt-20 lg:pt-6 justify-center",
  innerContainer: "lg:p-10 p-2 bg-white w-full max-w-7xl rounded-lg",
  betaStyle: "bg-blue-200 rounded-md px-4 py-1 w-fit",
  boldText: "font-bold my-3",
  marginY: "my-2",
  textAreaStyle:
    "w-full h-52 mt-5 bg-white border-8 rounded-lg p-4 border-gray-200",
  buttonContainer: "mt-5 text-right",
  submitButton: "text-white bg-blue-500 px-4 py-2 rounded-lg",
  cancelButton: "text-blue-500 bg-white mr-2 px-4 py-2",
  listItem: "my-2 flex gap-2 flex-shrink-0",
  numberCircle:
    "bg-gray-200 rounded-full w-6 h-6 flex items-center justify-center text-center flex-shrink-0",
};

export default AiFilterPage;
